import 'store/types'
import { Map } from 'immutable'
import { GIFT_SKU_PARAM_KEY } from './constants'

/**
 * @param {ReduxState} state redux state
 */
export const selectPath = (state) => {
  return state.resolver.get('path', '')
}

/**
 * @param {ReduxState} state redux state
 */
export function selectResolver (state) {
  return state.resolver || Map()
}

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */

export const selectLocation = (state) => selectResolver(state).get('location', Map())

/**
 * @param {String} storeKey resolver data param store key
 * @returns {selectResolverDataParamByKey~selectFromState}
 */
export const selectResolverDataParamByKey = (storeKey) => {
  if (!storeKey) {
    throw new Error('The storeKey option is required.')
  }

  /**
   * @param {ReduxState} state redux state
   */
  const selectFromState = (state) => {
    return state.resolver.getIn(['data', 'params', storeKey], '')
  }

  return selectFromState
}

/**
 * @param {String} storeKey resolver data param store key
 * @returns {selectResolverDataParamByKey~selectFromState}
 */
export const selectResolverQueryParamByKey = (storeKey) => {
  if (!storeKey) {
    throw new Error('The storeKey option is required.')
  }

  /**
   * @param {ReduxState} state redux state
   */
  const selectFromState = (state) => {
    return state.resolver.getIn(['query', storeKey], '')
  }
  return selectFromState
}

/**
 * @retuns {String} decoded sku
 */
export function selectResolverSKUParam (state) {
  return selectResolverDataParamByKey(GIFT_SKU_PARAM_KEY)(state)
}
